class MenuSelector {
    constructor(element) {
        this.element = element;
        this.processLinks();
    }

    processLinks() {
        let menu = this.getElement();
        let links = menu.querySelectorAll('a');
        let currentPath = document.location.pathname.replace('/', '').replace(/(\/)$/, '')
        for(let i = 0; i < links.length; i += 1) {
            let linkEl = links[i];
            let linkPath = linkEl.pathname.replace('/', '').replace(/(\/)$/, '');
            if(currentPath == '' || linkPath == '') {
                if(linkPath == currentPath) {
                    linkEl.classList.add('-nav-current');
                }
            } else {
                if(currentPath === linkPath) {
                    linkEl.classList.add('-nav-current');
                } else if(linkPath.startsWith(currentPath)) {
                    linkEl.classList.add('-nav-child');
                } else {
                    let ancestorPath = currentPath.replace(/\/[^\/]+$/, '');
                    while(ancestorPath !== '') {
                        if(linkPath === ancestorPath) {
                            linkEl.classList.add('-nav-ancestor');
                            break;
                        }
                        if(ancestorPath.indexOf('/') === -1) {
                            break;
                        }
                        ancestorPath = ancestorPath.replace(/\/[^\/]+$/, '');
                    }
                }
            }
        };
    }

    getElement() {
        return this.element;
    }

    static init() {
        document.querySelectorAll('.js-menu-selector').forEach(function(el) {
            new MenuSelector(el);
        });
    }
};

export default MenuSelector;
